import React, { ReactNode } from "react";
import { Box, Typography } from "@mui/material";

interface TitledContentProps {
    title: ReactNode;
    action?: ReactNode;
    children: ReactNode;
}

export const TitledContent: React.FC<TitledContentProps> = ({ title, action, children }) => {
    return (
        <Box maxWidth="800px">
            <Box
                sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    mb: 2,
                    gap: 1,
                }}
            >
                <Typography variant="h5">{title}</Typography>
                {action}
            </Box>
            <Box sx={{ borderTop: "1px solid", borderColor: "divider", my: 2 }} />
            {children}
        </Box>
    );
};
